import { BaseRequest } from '@/network/requests/BaseRequest';
import { user_rights } from '@/interfaces/user_rights';

export const userRightsRequest = BaseRequest.build<user_rights>('user_rights');